import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import isEmpty from 'lodash-es/isEmpty'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { Status, STATUS_SIZE_20 } from '../../../Status'
import Text from '../../../Text'

import * as styles from './ViewingApplicantPreviewSection.module.css'

function ViewingApplicantPreviewSection({
  section: { rows, titleKey } = EMPTY_OBJECT,
}) {
  const { t } = useTranslation()

  return (
    <div className={styles.ViewingApplicantPreviewSection}>
      <Text className={styles.title}>{t(titleKey)}</Text>
      {isEmpty(rows) ? (
        <Text isSecondary>{t('Select.NoDataKey')}</Text>
      ) : (
        <div className={styles.rows}>
          {rows.map(row => (
            <Fragment key={row.key}>
              <Text isSecondary className={styles.rowLabel}>
                {row.label}
              </Text>
              {row.statusProps ? (
                <Status
                  {...row.statusProps}
                  className={styles.rowStatus}
                  height={STATUS_SIZE_20}
                />
              ) : (
                <Text className={styles.rowValue}>{row.text}</Text>
              )}
            </Fragment>
          ))}
        </div>
      )}
    </div>
  )
}

export default ViewingApplicantPreviewSection
